import { createActions } from "redux-actions";

export default createActions({
  TABBAR: {
    MESSAGEBUTTON: {
      SET: (isUserSignedIn, isTabbarHide) => ({
        isUserSignedIn,
        isTabbarHide,
      }),
      SUCCESS: (data) => ({
        data,
      }),
      FAILURE: (error) => ({
        error,
      }),
    },
  },
});
